<template>
    <b-button-group :variant="Variant" :class="'rounded-pill bg-' + Variant" >
        <!-- Favoris enregistrés par l'utilisateur -->
        <b-dropdown :disabled="Disabled || Bookmarks?.length == 0" ref="bookmarkDropdownRef" no-caret menu-class="py-0" toggle-class="rounded-pill border-right pl-2 pr-2 mr-1" > 
            <template #button-content>
                <b-icon icon="star-fill" v-b-tooltip.left.noninteractive.hover :title="$t('Favorites')" class="text-white" />
            </template>
            <BookmarksMenu ref="bookmarkMenuRef" :Bookmarks="Bookmarks" :Variant="Variant" :minWidthMenu="minWidthMenu" :maxHeightMenu="maxHeightMenu" @selectFeatureEvent="selectFeature($event,true)"/>
        </b-dropdown>
        <!-- Liste des fonctions -->
        <b-dropdown ref="featureDropdownRef" :disabled="Disabled" right menu-class="py-0" toggle-class="rounded-pill border-0 pl-1" no-flip>
            <!-- Path du menu en cour d'utilisation affiché dans le bouton -->
            <template #button-content>
                <b>{{ checkSmPortrait() ? $tc("Feature", 2): featurePathLabels  }}</b>
            </template>
            <FeaturesMenu ref="featureMenuRef" :Variant="Variant" :Disabled="Disabled" :MinWidthMenu="minWidthMenu" :MaxHeightMenu="maxHeightMenu" 
                @selectFeatureEvent="selectFeature($event,false)" @toggleBookmarkEvent="toggleBookmark($event)" />
        </b-dropdown>
    </b-button-group>
</template>

<script lang="ts">
    /** Importe les d�corateurs pour utiliser @Component et @Prop */
    import { Component, Prop } from 'vue-property-decorator';
    import { Getter } from 'vuex-class';

    /** Types custom import� depuis /types */
    import Feature from '@/types/Feature';
    import Bookmark from '@/types/Bookmark';

    import { ScreenUtils } from '@/components/commons/Utils';

    /** Traductions du composant */
    import locales from "./locales/Features.json";

    /** Traductions de la liste des fonctions */
    import featuresLocales from "@/locales/features.json";
    import { BDropdown } from 'bootstrap-vue';

    import BookmarksMenu from './Features/BookmarksMenu.vue';
    import FeaturesMenu from './Features/FeaturesMenu.vue';

    /** Composant d'affichage du menu listant les fonctions */
    @Component({
        components:{
            BookmarksMenu,
            FeaturesMenu
        },
        i18n: { messages: locales }
    })
    export default class Features extends ScreenUtils {
        /** Variant de thème utilisé par les pères */
        @Prop({ default: "primary" })
        public Variant!: string;

        /** Indique si le bouton de liste des fonctions est d�sactiv� ou non */
        @Prop({ default: false })
        public Disabled!: boolean;

        /** Largueur horizontale minimal du menu */
        @Prop({ default: "19rem" })
        public minWidthMenu : string;

        /** Hauteur vertical maximum du menu */                 
        @Prop({ default: "80dvh" })
        public maxHeightMenu: string;

        /** Chemin vers la fonction s�lectionn�e avec ses labels */
        @Getter('GetFeaturePathLabels')
        private featurePathLabels!: string;

        /** Liste des bookmarks à charger sous forme de menu */
        @Getter('GetBookmarksMenu')
        private Bookmarks!: Bookmark[];

        //#region *** Relai d'event ***

        /**
         * Route les demandes d'ajout de bookmark
         * @param feature Fonctionnalité cible.
         */
        private toggleBookmark(feature: Feature) {
            (this.$refs.bookmarkMenuRef as BookmarksMenu).ToggleBookmark(feature);
        }

        /**
         * Récupère l'event de choix de fonctionnalité de la part de "BookmarkMenu" et "FeatureMenu" pour des soucis visuel.
         * @param selectedFeature Fonctionnalité selectionée.
         * @param isFromBookmark Si proviens de bookmark alors on demande à FeatureMenu d'effectué le changement de menu
         */
        private selectFeature(selectedFeature: Feature, isFromBookmark: boolean) {

            if(isFromBookmark) {
                let featureMenu: FeaturesMenu = this.$refs.featureMenuRef as FeaturesMenu;
                if (featureMenu)
                    featureMenu.selectFeature(selectedFeature);
            }
            
            let featureDropdown = this.$refs.featureDropdownRef as BDropdown;
            if (featureDropdown)
                featureDropdown.hide();

            let dropdownBookmark = this.$refs.bookmarkDropdownRef as BDropdown;
            if (dropdownBookmark)
                dropdownBookmark.hide();
        }
        //#endregion *** Relai d'event ***

        //#region *** Initialisation ***

        /** Methode d'initialisation de la vue */
        async created() {
            /** Chargement des traductions des features */
            this.$root.$i18n.mergeLocaleMessage(this.$i18n.locale, featuresLocales[this.$i18n.locale]);
        }
        //#endregion *** Initialisation ***
    }
</script>

<style scoped>
</style>